module.exports = __webpack_public_path__ + "img/eleph.c8cfe8fa.jpg";